import { ApolloLink } from "@apollo/client";
import { stableStringify } from "@sail/utils";
import createMulticastObservable from "./createMulticastObservable";
import stringifyGraphQlVars from "./stringifyGraphQlVars";
import { getOperationType } from "../shared/utils/gql";
export default function createDeduplicationLink() {
    const cacheByGql = new Map();
    return new ApolloLink(function deduplicationLink(operation, forward) {
        if (getOperationType(operation.query) === 'mutation') {
            return forward(operation);
        }
        const context = operation.getContext();
        var _context_operationHash;
        const hash = (_context_operationHash = context === null || context === void 0 ? void 0 : context.operationHash) !== null && _context_operationHash !== void 0 ? _context_operationHash : stableStringify(operation.query);
        var _cacheByGql_get;
        const cacheByVars = (_cacheByGql_get = cacheByGql.get(hash)) !== null && _cacheByGql_get !== void 0 ? _cacheByGql_get : new Map();
        const vars = stringifyGraphQlVars(operation.variables);
        const cachedObservable = cacheByVars.get(vars);
        if (cachedObservable) {
            operation.setContext({
                isDeduplicated: true
            });
            return cachedObservable;
        }
        cacheByGql.set(hash, cacheByVars);
        const requestObservable = forward(operation);
        function cleanupCache() {
            cacheByVars.delete(vars);
            if (cacheByVars.size === 0) {
                cacheByGql.delete(hash);
            }
        }
        const newObservable = createMulticastObservable(requestObservable, {
            complete: cleanupCache,
            unsubscribe: cleanupCache
        });
        cacheByVars.set(vars, newObservable);
        return newObservable;
    });
}

//# sourceMappingURL=createDeduplicationLink.js.map